import { useEffect, useState } from "react";
import {MessageCircleDashed as MessageCircle, X} from 'lucide-react';

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setTooltipOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const phone = "5521973516085";
  const message = encodeURIComponent(
    "Olá! Vim pelo site da Manguenela Rio e gostaria de mais informações."
  );
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      {/* Tooltip card */}
      {tooltipOpen ? (
        <div className="hidden sm:flex flex-col bg-white rounded-2xl shadow-2xl border border-gray-100 px-5 py-4 max-w-xs animate-fade-in relative">
          <button
            onClick={() => setTooltipOpen(false)}
            aria-label="Fechar"
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
          >
            <X size={14} />
          </button>
          <p className="text-[#0D1B3E] font-bold text-sm mb-1">
            Atendimento Manguenela Rio
          </p>
          <p className="text-gray-500 text-xs leading-relaxed">
            Olá! Estamos online. Solicite seu orçamento agora pelo WhatsApp.
          </p>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-xs uppercase tracking-wide px-4 py-2 rounded-lg transition-colors"
          >
            <MessageCircle size={14} />
            Iniciar Conversa
          </a>
          {/* Pointer */}
          <div className="absolute -right-2 bottom-6 w-4 h-4 bg-white border-r border-b border-gray-100 rotate-[-45deg]" />
        </div>
      ) : null}

      {/* Floating button */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar no WhatsApp"
        className="relative group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <span className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full shadow-2xl shadow-[#25D366]/40 transition-all duration-200 hover:scale-110">
          <MessageCircle size={26} />
        </span>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#F5A623] border-2 border-white rounded-full" />
      </a>
    </div>
  );
}
